<template>
	<div class="System">
		<!-- <div @click="goToParameter">
		<img src="../../../assets/img/System1.png" alt="">
	</div> -->
		<div @click="goToUser">
			<label>参数<br />配置</label>
			<img src="../../../assets/img/System4.png" alt="">
		</div>
		<!-- <div @click="goToTaskSetting">
    <label>任务<br/>设置</label>
		<img src="../../../assets/img/System4.png" alt="">
	</div> -->
		<div @click="goToUsers">
			<label>用户<br />管理</label>
			<img src="../../../assets/img/System4.png" alt="">
		</div>
		<div @click="goToRestart">
			<label>系统<br />重启</label>
			<img src="../../../assets/img/System4.png" alt="">
		</div>
	</div>
</template>

<script>
	import {
		Reboot
	} from '../../../api/request.js'
	export default {
		name: "System",
		data() {
			return {
isAdmin:false,
			}
		},
		created() {
			let user = JSON.parse(sessionStorage.getItem("userData")).userName;
			if(user=="admin"){
				this.isAdmin=true;
			}
		},
		methods: {
			Reboots() {
				Reboot().then(res => {
					console.log(res)
				})
			},
			goToUser() {
				this.$router.push("/SystemSet/User")
			},
			goToUsers () {
				this.$router.push("/SystemSet/Users")
			},
			goToRestart() {
				this.$confirm('是否需要重启系统?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.Reboots()
					this.$message({
						type: 'success',
						duration: 800,
						message: '重启成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						duration: 800,
						message: '已取消操作'
					});
				});
			},
			goToTaskSetting() {
				this.$router.push("/SystemSet/taskSetting")
			}
		}
	}
</script>

<style lang="less" scoped>
	.System div img:hover {
		transform: scale(1.02);
		transition: linear 0.2s;
	}

	.System {
		width: 80%;
		height: 100%;
		margin: auto;
		overflow: hidden;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;

		div {
			position: relative;
			cursor: pointer;

			label {
				color: #fff;
				// font-family: '华文琥珀';
				font-weight: bolder;
				position: absolute;
				z-index: 99;
				top: 50%;
				left: 50%;
				margin-top: -22px;
				margin-left: -20px;
				line-height: 22px;
				letter-spacing: 5px;
				font-size: 16px;
				font-style: oblique;
				cursor: pointer;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/SystemSet/index/index.vue